module.exports = __webpack_public_path__ + "img/thumbnail_Okapi_m_normal.836e449c.png";